import { render, staticRenderFns } from "./ModalBuscarCliente.vue?vue&type=template&id=aaffab5e&scoped=true&"
import script from "./ModalBuscarCliente.vue?vue&type=script&lang=js&"
export * from "./ModalBuscarCliente.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aaffab5e",
  null
  
)

export default component.exports